import { Check, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export interface EnrollmentConfirmButtonProps {
  bookingId: string;
  confirmingBookingId: string | null;
  disabled?: boolean;
  onConfirm: (bookingId: string) => void;
  /** Chip merges the unconfirmed tag and confirm action into one control */
  variant?: 'button' | 'chip';
}

export function EnrollmentConfirmButton({
  bookingId,
  confirmingBookingId,
  disabled = false,
  onConfirm,
  variant = 'button',
}: EnrollmentConfirmButtonProps) {
  const isLoading = confirmingBookingId === bookingId;
  const anotherInFlight = confirmingBookingId != null && !isLoading;
  const isDisabled = disabled || anotherInFlight || isLoading;

  if (variant === 'chip') {
    return (
      <button
        type="button"
        title="Confirm unconfirmed booking"
        aria-label="Confirm unconfirmed booking"
        disabled={isDisabled}
        onClick={() => onConfirm(bookingId)}
        className="inline-flex h-6 w-[5.75rem] shrink-0 items-center justify-center rounded px-1.5 text-[10px] font-medium bg-amber-100 text-amber-900 transition-colors hover:bg-amber-200 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-amber-900/50 dark:text-amber-100 dark:hover:bg-amber-900/70"
      >
        {isLoading ? (
          <Loader2 className="h-3 w-3 animate-spin" aria-hidden />
        ) : (
          <span>Unconfirmed</span>
        )}
      </button>
    );
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className="h-8 shrink-0 gap-1.5 text-green-700 dark:text-green-300"
      disabled={isDisabled}
      onClick={() => onConfirm(bookingId)}
    >
      {isLoading ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
          …
        </>
      ) : (
        <>
          <Check className="h-4 w-4" aria-hidden />
          Confirm
        </>
      )}
    </Button>
  );
}
